import sdl from '@jds/react-generated-sdl/JDSNudgeContainer';
import type { JDSNudgeContainerProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSNudgeContainerProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const { custom = '', ...rest } = props as any;
  return createComponent(
    json,
    rest,
    'JDSNudgeContainer',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const NudgeContainer = withLogic(
  Component
) as React.FC<JDSNudgeContainerProps> & { slotName?: string };

NudgeContainer.displayName = 'NudgeContainer';
NudgeContainer.slotName = 'jds_nudge_container';

export { NudgeContainer, type JDSNudgeContainerProps };
